"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../../..");

var _excluded = ["children"];

var CalendarWeekday = function CalendarWeekday(_ref) {
  var children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_.Box, (0, _extends2["default"])({
    width: 1 / 7
  }, rest), /*#__PURE__*/_react["default"].createElement(_.Text, null, children));
};

CalendarWeekday.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = CalendarWeekday;
exports["default"] = _default;